import { OvTableData } from '../../../components/UI/molecules/OvTable';
import i18n from '../../../i18n/config';
import { Constants } from '../../constants';
import { PhysicalProduct } from '../../model/dto/physical-product/physical-product';
import { getCountriesSelectOptions } from '../../model/dto/shipping-rate/countries-select-options';
import { TableRowEditWidgetType } from '../../model/ui/table-row-edit-widget.type';
import StringUtils from './string-utils';

export const mapPhysicalProductToTableDataFormat = (
  physicalProduct?: PhysicalProduct
): OvTableData => {
  return [
    {
      label: 'physicalProducts.fields.internalName',
      value: physicalProduct?.internal_name,
      translateLabel: true,
      editOptions: {
        widgetType: TableRowEditWidgetType.TEXT,
        propertyName: 'internal_name',
        placeholder: i18n.t('physicalProducts.fields.internalName'),
      },
    },
    {
      label: 'physicalProducts.fields.title',
      value: physicalProduct?.title,
      translateLabel: true,
      editOptions: {
        widgetType: TableRowEditWidgetType.TEXT,
        propertyName: 'title',
        placeholder: i18n.t('physicalProducts.fields.title'),
      },
    },
    {
      label: 'physicalProducts.fields.subtitle',
      value: physicalProduct?.subtitle,
      translateLabel: true,
      editOptions: {
        widgetType: TableRowEditWidgetType.TEXT,
        propertyName: 'subtitle',
        placeholder: i18n.t('physicalProducts.fields.subtitle'),
      },
    },
    {
      label: 'physicalProducts.fields.description',
      value: physicalProduct?.description,
      translateLabel: true,
      displayAsHTML: true,
      editOptions: {
        widgetType: TableRowEditWidgetType.FORMATTED_TEXT_AREA,
        propertyName: 'description',
        placeholder: i18n.t('physicalProducts.fields.description'),
      },
    },
    {
      label: 'physicalProducts.fields.cta',
      value: physicalProduct?.cta,
      translateLabel: true,
      editOptions: {
        widgetType: TableRowEditWidgetType.TEXT,
        propertyName: 'cta',
        placeholder: i18n.t('physicalProducts.fields.cta'),
      },
    },
    {
      label: 'physicalProducts.fields.sku',
      value: physicalProduct?.sku,
      translateLabel: true,
      editOptions: {
        widgetType: TableRowEditWidgetType.TEXT,
        propertyName: 'sku',
        placeholder: i18n.t('physicalProducts.fields.sku'),
      },
    },
    {
      label: 'physicalProducts.fields.imageUrl',
      value: physicalProduct?.image_url,
      translateLabel: true,
    },
    {
      label: 'physicalProducts.fields.thumbnailImageUrl',
      value: physicalProduct?.thumbnail_image_url,
      translateLabel: true,
    },
    {
      label: 'physicalProducts.fields.stripePriceId',
      value: physicalProduct?.stripe_price_id,
      translateLabel: true,
      linkUrl: `https://dashboard.stripe.com/${
        !Constants.IS_PRODUCTION ? 'test/' : ''
      }prices/${physicalProduct?.stripe_price_id}`,
    },
    {
      label: 'physicalProducts.fields.displayPrice',
      value: physicalProduct?.display_price,
      translateLabel: true,
    },
    {
      label: 'physicalProducts.fields.unitAmount',
      value: physicalProduct?.unit_amount,
      translateLabel: true,
    },
    {
      label: 'physicalProducts.fields.platform',
      value: physicalProduct?.platform,
      translateLabel: true,
    },
    {
      label: 'physicalProducts.fields.type',
      value: physicalProduct?.type,
      translateLabel: true,
    },
    {
      label: 'physicalProducts.fields.countries',
      value: physicalProduct?.countries,
      translateLabel: true,
      editOptions: {
        options: getCountriesSelectOptions(),
        propertyName: 'countries',
        widgetType: TableRowEditWidgetType.MULTI_SELECT,
      },
    },
    {
      label: 'physicalProducts.fields.numberOfStripsIncluded',
      value: physicalProduct?.number_of_strips_included,
      translateLabel: true,
      editOptions: {
        propertyName: 'number_of_strips_included',
        widgetType: TableRowEditWidgetType.NUMBER,
        min: 0,
      },
    },
    {
      label: 'physicalProducts.fields.isActive',
      value: physicalProduct?.is_active,
      prettifiedValue: StringUtils.getPrettifiedBooleanValue(
        physicalProduct?.is_active
      ),
      translateLabel: true,
      editOptions: {
        propertyName: 'is_active',
        widgetType: TableRowEditWidgetType.BOOLEAN,
      },
    },
  ];
};
